"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var am4core = _interopRequireWildcard(require("@amcharts/amcharts4/core"));

var _themeUi = require("theme-ui");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var amChartTooltip = function amChartTooltip(tooltip) {
  var create = function create(id) {
    var amTooltip = new am4core.Tooltip();
    amTooltip.id = id;
    return amTooltip;
  };

  var setDefaultStyles = function setDefaultStyles(theme) {
    var textStyles = (0, _themeUi.css)({
      variant: 'textStyles.caption'
    })(theme);
    tooltip.getFillFromObject = false;
    tooltip.autoTextColor = false;
    tooltip.fillOpacity = 1;
    tooltip.label.minWidth = theme.sizes[9];
    tooltip.label.wrap = true;
    tooltip.label.maxWidth = theme.sizes[11];
    tooltip.label.element.attr({
      'letter-spacing': textStyles.letterSpacing
    });
    tooltip.label.fill = am4core.color('white');
    tooltip.label.fontSize = textStyles.fontSize;
    tooltip.label.paddingTop = 4;
    tooltip.label.paddingBottom = 4;
    tooltip.label.paddingLeft = 6;
    tooltip.label.paddingRight = 6;
    tooltip.label.textAlign = 'middle';
    tooltip.background.fillOpacity = 1;
    tooltip.background.fill = am4core.color(theme.colors.neutral[5]);
    tooltip.background.opacity = 1;
    tooltip.background.strokeWidth = 0;
    tooltip.background.cornerRadius = theme.radii.medium;
    tooltip.background.filters.clear();
    tooltip.dy = -4;
    return tooltip;
  };

  return {
    create: create,
    setDefaultStyles: setDefaultStyles
  };
};

var _default = amChartTooltip;
exports["default"] = _default;